/* stylelint-disable selector-class-pattern */
import styled from "@emotion/styled";

import tourFox from "./Fox1.png";
import tourFox1 from "./Fox2.png";
export const Content = styled.div({});

export const FoxImage = styled.div({
    float: "left",
});

export const Root = styled.div<{ kewebStyle?: "keweb" | "keweb1" | string; width?: number }>(
    props =>
        props.kewebStyle !== "keweb" &&
        props.kewebStyle !== "keweb1" && {
            padding: "30px 35px 45px 40px",
            width: props.width ?? 425,
        },
    props =>
        props.kewebStyle === "keweb" && {
            padding: "40px 30px 50px",
            width: 540,

            "::after": {
                content: '""',
                display: "table",
                clear: "both",
            },

            [`${Content}`]: {
                float: "left",
                marginTop: -25,
                width: 415,
            },

            [`${FoxImage}`]: {
                width: 125,
                height: 158,
                background: `url(${tourFox}) no-repeat`,
            },
        },
    props =>
        props.kewebStyle === "keweb1" && {
            padding: "25px 30px 35px 10px",
            width: 660,

            "::after": {
                content: '""',
                display: "table",
                clear: "both",
            },

            [`${Content}`]: {
                float: "left",
                marginTop: 25,
                width: 380,
            },

            [`${FoxImage}`]: {
                margin: "40px 20px 0 0",
                width: 210,
                height: 200,
                background: `url(${tourFox1}) no-repeat`,
                backgroundSize: "contain",
            },
        }
);

export const Header = styled.div({
    fontSize: "26px",
});

export const Body = styled.div({
    margin: "20px 0 30px",
    fontSize: "18px",
});

export const Footer = styled.div({
    display: "inline-block",
});
